module.exports = __webpack_public_path__ + "img/IMG_9874-1.640bccc4.png";